export default "__VITE_ASSET__f6d1d724__"